export const errorUiVi = {
  network_error: 'Không kết nối được với máy chủ. Kiểm tra kết nối mạng rồi thử lại.',
  request_timeout: 'Máy chủ chưa phản hồi trong thời gian cho phép. Kiểm tra kết quả thao tác trước khi thử lại.',
  request_cancelled: 'Yêu cầu đã bị hủy.',
  session_changed: 'Phiên đăng nhập đã thay đổi khi đang xử lý yêu cầu. Tải lại trang để tiếp tục.',
  unauthorized: 'Phiên đăng nhập đã hết hạn hoặc chưa đăng nhập. Vui lòng đăng nhập lại.',
  invalid_request: 'Yêu cầu không hợp lệ. Kiểm tra các thông tin được đánh dấu.',
  method_not_allowed: 'Máy chủ không hỗ trợ thao tác này.',
  unsupported_media_type: 'Định dạng dữ liệu gửi lên không được hỗ trợ.',
  too_many_requests: 'Có quá nhiều yêu cầu. Vui lòng chờ rồi thử lại.',
  internal_error: 'Máy chủ gặp lỗi khi xử lý yêu cầu. Vui lòng thử lại hoặc báo quản trị viên kèm mã tra cứu.',
  reference_id: 'Mã tra cứu',
  copy_reference: 'Sao chép mã tra cứu',
  reference_copied: 'Đã sao chép mã tra cứu',
  bad_gateway: 'Cổng kết nối chưa nhận được phản hồi hợp lệ từ dịch vụ xử lý. Vui lòng thử lại.',
  service_unavailable: 'Dịch vụ xử lý tạm thời chưa sẵn sàng. Vui lòng thử lại sau.',
  gateway_timeout: 'Dịch vụ xử lý chưa phản hồi kịp thời. Kiểm tra kết quả thao tác trước khi thử lại.',
  field_required: 'Vui lòng nhập thông tin này.',
  field_invalid: 'Giá trị chưa hợp lệ.',
  field_invalid_email: 'Địa chỉ email chưa hợp lệ.',
  field_min_length: 'Cần nhập ít nhất {min} ký tự.',
  field_max_length: 'Chỉ được nhập tối đa {max} ký tự.',
  field_length: 'Cần nhập từ {min} đến {max} ký tự.',
  field_range: 'Giá trị phải nằm trong khoảng {min} đến {max}.',
  field_exclusive_range: 'Giá trị phải lớn hơn {min} và nhỏ hơn {max}.',
  field_greater_than: 'Giá trị phải lớn hơn {value}.',
  field_greater_than_or_equal: 'Giá trị phải lớn hơn hoặc bằng {value}.',
  field_less_than: 'Giá trị phải nhỏ hơn {value}.',
  field_less_than_or_equal: 'Giá trị phải nhỏ hơn hoặc bằng {value}.',
  field_equal: 'Giá trị phải bằng {value}.',
  field_not_equal: 'Giá trị phải khác {value}.',
  field_invalid_format: 'Định dạng chưa hợp lệ.',
  field_invalid_enum: 'Giá trị không thuộc danh sách cho phép.',
  field_invalid_json: 'Dữ liệu gửi lên sai định dạng hoặc sai kiểu. Kiểm tra trường này.'
}
export const errorUiEn = {
  network_error: 'Cannot connect to the server. Check your network connection and try again.',
  request_timeout: 'The server did not respond in time. Check the operation result before retrying.',
  request_cancelled: 'The request was cancelled.',
  session_changed: 'The signed-in session changed while the request was being processed. Reload the page to continue.',
  unauthorized: 'Your session has expired or you are not signed in. Please sign in again.',
  invalid_request: 'The request is invalid. Check the highlighted information.',
  method_not_allowed: 'The server does not support this operation.',
  unsupported_media_type: 'The submitted data format is not supported.',
  too_many_requests: 'Too many requests. Please wait and try again.',
  internal_error: 'The server could not process the request. Try again or contact an administrator with the reference ID.',
  reference_id: 'Reference ID',
  copy_reference: 'Copy reference ID',
  reference_copied: 'Reference ID copied',
  bad_gateway: 'The gateway did not receive a valid response from the service. Please try again.',
  service_unavailable: 'The service is temporarily unavailable. Please try again later.',
  gateway_timeout: 'The service did not respond in time. Check the operation result before retrying.',
  field_required: 'Enter a value for this field.',
  field_invalid: 'This value is invalid.',
  field_invalid_email: 'Enter a valid email address.',
  field_min_length: 'Enter at least {min} characters.',
  field_max_length: 'Enter no more than {max} characters.',
  field_length: 'Enter between {min} and {max} characters.',
  field_range: 'The value must be between {min} and {max}.',
  field_exclusive_range: 'The value must be greater than {min} and less than {max}.',
  field_greater_than: 'The value must be greater than {value}.',
  field_greater_than_or_equal: 'The value must be greater than or equal to {value}.',
  field_less_than: 'The value must be less than {value}.',
  field_less_than_or_equal: 'The value must be less than or equal to {value}.',
  field_equal: 'The value must equal {value}.',
  field_not_equal: 'The value must not equal {value}.',
  field_invalid_format: 'Enter a value in the correct format.',
  field_invalid_enum: 'Select one of the allowed values.',
  field_invalid_json: 'The submitted data has an invalid format or type. Check this field.'
} satisfies Record<keyof typeof errorUiVi, string>
